import { createWebworker } from "../src/index.ts";
import { type WorkerType } from "./test-worker.ts";

const worker = await createWebworker<WorkerType>(new URL('./test-worker.js', import.meta.url), {type: "module"}) 

console.log(await worker.greet("Bob"));
console.log(await worker.greet2());
console.log(await worker.greet3("bob", "joe"));

const cancel = await worker.withCallback((text) => console.log(text));

setTimeout(() => cancel(), 10000)

//worker.terminate()